import { TextAlignment } from '../../canvas/entities/TextConventions';
import { SimpleTextField } from '../../canvas/fields/SimpleTextField';

export abstract class StopwatchField extends SimpleTextField {

    public readonly fontColor: string = '#fff';
    public readonly fontFamily: string = 'Roboto Condensed';
    public readonly fontSize: number = 64;
    public readonly fontWeight: number = 700;
    public readonly lineHeight: number = 1;
    public readonly maxLength = 3;
    public readonly textAlignH = TextAlignment.middle;
    public readonly textAlignV = TextAlignment.middle;
    public readonly textMargin: number | number[] = 4;

    public get default() {
        return true;
    }
}

// export class StopwatchMinutes extends StopwatchField {

//     public get layout(): FieldLayout {
//         return new FieldLayout(this.owner.cast(Stopwatch).layout.minutes, 2);
//     }

//     public get default() {
//         return true;
//     }
// }

// export class StopwatchSeconds extends StopwatchField {

//     public get layout(): FieldLayout {
//         return new FieldLayout(this.owner.cast(Stopwatch).layout.seconds, 2);
//     }

//     public get default() {
//         return true;
//     }
// }

import { TextSettings } from '../../canvas/entities/TextConventions';
import { UIField } from '../../canvas/entities/UIField';
import { CreateUnstyledTextFieldEditor } from '../../canvas/workspace/adapters/UnstyledTextFieldEditor';
import { Stopwatch } from './Stopwatch';

export const StopwatchFieldTextSettings = TextSettings.from({
    ...TextSettings.default,
    lineHeight: 1,
    fontSize: 40,
    maxFontSize: 40,
    fontColor: '#fff',
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
});

export const StopwatchMinutesFieldTextSettings = TextSettings.from({
    ...StopwatchFieldTextSettings,
    fontSize: 0,
    textAlignH: TextAlignment.end,
});

export const StopwatchSecondsFieldTextSettings = TextSettings.from({
    ...StopwatchFieldTextSettings,
    fontSize: 0,
    textAlignH: TextAlignment.start,
});

const StopwatchMinutesFieldEditor = CreateUnstyledTextFieldEditor('minutes', () => StopwatchMinutesFieldTextSettings);
const StopwatchSecondsFieldEditor = CreateUnstyledTextFieldEditor('seconds', () => StopwatchSecondsFieldTextSettings);

export const StopwatchMinutesField = (owner: Stopwatch): UIField => ({
    ui: StopwatchMinutesFieldEditor,
    name: 'minutes',
    bounds: owner.layout.minutes,
    owner,
});

export const StopwatchSecondsField = (owner: Stopwatch): UIField => ({
    ui: StopwatchSecondsFieldEditor,
    name: 'seconds',
    bounds: owner.layout.seconds,
    owner,
});
